module.exports = __webpack_public_path__ + "static/media/design-light.160ecd1b.svg";